module.exports = __webpack_public_path__ + "static/primary-5b0b4ea769458c86c5e4e2c78b8d310a.mp4";